export default __webpack_public_path__ + "static/media/joinus_img_03_data.80887b24.svg";